import { render } from "./CategoryGrid.vue?vue&type=template&id=3ba8afdb"
import script from "./CategoryGrid?vue&type=script&lang=js"
export * from "./CategoryGrid?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__